import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Theme = "dark" | "light" | "midnight" | "high-contrast";

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({ theme: "dark" as Theme, setTheme: (theme) => set({ theme }) }),
    { name: "sq-admin-theme" }
  )
);

export const THEME_VARS: Record<Theme, Record<string, string>> = {
  dark: {
    "--bg":         "#0a0a12",
    "--surface":    "#12121f",
    "--surface2":   "#1a1a2e",
    "--border":     "rgba(255,255,255,0.08)",
    "--text":       "rgba(240,240,255,0.85)",
    "--text-muted": "rgba(255,255,255,0.4)",
    "--accent":     "#a855f7",
    "--accent-dim": "rgba(168,85,247,0.15)",
  },
  light: {
    "--bg":         "#f8fafc",
    "--surface":    "#ffffff",
    "--surface2":   "#f1f5f9",
    "--border":     "#e2e8f0",
    "--text":       "#1e293b",
    "--text-muted": "#94a3b8",
    "--accent":     "#7c3aed",
    "--accent-dim": "#ede9fe",
  },
  midnight: {
    "--bg":         "#020617",
    "--surface":    "#0c1222",
    "--surface2":   "#111827",
    "--border":     "rgba(255,255,255,0.07)",
    "--text":       "rgba(240,248,255,0.9)",
    "--text-muted": "rgba(255,255,255,0.4)",
    "--accent":     "#0ea5e9",
    "--accent-dim": "rgba(14,165,233,0.15)",
  },
  "high-contrast": {
    "--bg":         "#000000",
    "--surface":    "#0a0a0a",
    "--surface2":   "#111111",
    "--border":     "rgba(250,204,21,0.4)",
    "--text":       "#ffffff",
    "--text-muted": "rgba(255,255,255,0.6)",
    "--accent":     "#facc15",
    "--accent-dim": "rgba(250,204,21,0.1)",
  },
};
